import * as SAGAS from '../constants/constant_saga_types';

const INIT_STATE = {
  search_term: null,
  search_results: [],
  total_result: 0,
  searching: false,
  error: {
    isError: false,
    message: null,
  },
  force_show_results: false,
};

export default function (state = INIT_STATE, action) {
  switch (action.type) {
    case SAGAS.SEARCHING_TERM:
      return {
        ...state,
        searching: true,
        error: {
          isError: false,
          message: null,
        },
      };

    case SAGAS.DONE_SEARCHING_TERM:
      const { total, docs, search_term } = action.payload || {};
      return {
        ...state,
        search_term,
        total_result: total,
        search_results: docs,
        searching: false,
      };

    case SAGAS.ERROR_SEARCHING_TERM:
      const { error } = action;

      return {
        ...state,
        searching: false,
        error: { ...error, isError: true },
      };

    case SAGAS.RESET_SEARCH_TERM:
      return INIT_STATE;

    case SAGAS.FORCE_SHOW_RESULTS:
      const { force_show_results } = action;
      return {
        ...state,
        force_show_results,
      };

    default:
      return state;
  }
}
